import React from 'react'
import {
  ModalOverlay,
  ModalCloseButton,
  ModalContent,
} from '../../style/StyledElement'
import ClearButton from './Button'
import Box from '@mui/material/Box'
import CloseIcon from '@mui/icons-material/Close';
import SpinnerButton from './SpinnerButton';
const Modal = ({ children, onConfirm, onClose }) => {
  return (
    <ModalOverlay >
      <ModalContent sx={{backgroundColor: '#27326E'}}>
        {children}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', mt:0 }}>
          <SpinnerButton label={'Yes'} onClick={onConfirm}/>
          <SpinnerButton label={'No'} onClick={onClose}/>
        </Box>
        <ModalCloseButton onClick={onClose}><CloseIcon/></ModalCloseButton>
      </ModalContent>
    </ModalOverlay>
  )
}

export default Modal
